import {Button, Stack, Typography} from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';
import Tooltip from "@mui/material/Tooltip";
import LevelsDataGrid from "./LevelsDataGrid";
import {useState} from "react";
import LevelBarChart from "./LevelBarChart";
import OrganisationDataGrid from "./OrganisationDataGrid";
import {payLevelsExport} from "../../hooks/PayLevelsSearches";
import {useAuth} from "../../auth/AuthProvider";
import {ExportLink, Tab, TabPanel, Tabs} from "../Tabs";
import {copyToClipboard} from "../utils/DataGridUtils";

const labels = [
    "Job Level",
    "Region",
    "Sector / Industry",
];

const fixedColumnLabels = {
    salaryCount: "Salary Count",
    companyCount: "Company Count",
    lowerQuartile: "Lower Quartile",
    medianQuartile: "Median",
    upperQuartile: "Upper Quartile",
    average: "Average",
};

const viewBy = [
    "levels",
    "regions",
    "sectors",
];

const LevelTabs = ({data, isLoading, setViewBy, filters, bouncedFilters, updateFilters}) => {
    const {token} = useAuth();
    const [activeTab, setActiveTab] = useState(0);
    const [activeGridTab, setActiveGridTab] = useState(0);
    const [copyAlert, setCopyAlert] = useState(false);

    const summaryColumnLabels = {...fixedColumnLabels, firstColumn: labels[activeTab]};

    const selectTab = (event, newTab) => {
        setActiveTab(newTab);
        setViewBy(viewBy[newTab]);
    };

    const selectGridTab = (event, newGridTab) => {
        setActiveGridTab(newGridTab);
    };

    const exportData = () => {
        payLevelsExport(token, filters, viewBy[activeTab]).then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'payLevels.csv');
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        })
    };

    const copySummaryToClipboard = () => {
        let output = labels[activeTab] + "\t" + Object.values(fixedColumnLabels).join("\t") + "\n";
        output += data.rows.map((item) => {
            const fullString = Object.values(item).join("\t");
            const firstTab = fullString.indexOf("\t");
            return fullString.substring(firstTab + 1);
        }).join("\n");

        copyToClipboard(output, setCopyAlert);
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setCopyAlert(false);
    };

    return (
        <Stack sx={{width: "100%", overflowX: 'auto'}}>
            <Tabs value={activeTab} onChange={selectTab} variant="scrollable">
                <Tab id="tab-0" name="tab-0" label={labels[0]}/>
                <Tab id="tab-1" name="tab-1" label={labels[1]}/>
                <Tab id="tab-2" name="tab-2" label={labels[2]}/>
            </Tabs>

            <TabPanel index={0} activeTab={activeTab}>
                <LevelBarChart id="view_levels" data={data} isLoading={isLoading} label={labels[0]}/>
            </TabPanel>
            <TabPanel index={1} activeTab={activeTab}>
                <LevelBarChart id="view_regions" data={data} isLoading={isLoading} label={labels[1]}/>
            </TabPanel>
            <TabPanel index={2} activeTab={activeTab}>
                <LevelBarChart id="view_sectors" data={data} isLoading={isLoading} label={labels[2]}/>
            </TabPanel>

            <Stack direction="row" alignItems="center">
                <Typography>Summary | </Typography>
                <Button size="small" onClick={copySummaryToClipboard}>
                    <Tooltip title="Copies summary table data to clipboard">
                        <ExportLink>Copy</ExportLink>
                    </Tooltip>
                </Button>
                <Typography> | </Typography>
                <Button size="small" onClick={exportData}><ExportLink>Export</ExportLink></Button>
            </Stack>

            <Tabs value={activeGridTab} onChange={selectGridTab} variant="scrollable">
                <Tab id="tab-levels" name="tab-levels" label="Summary Table"/>
                <Tab id="tab-organisation" name="tab-organisation" label="Organisation Table"/>
            </Tabs>

            <TabPanel index={0} activeTab={activeGridTab}>
                <LevelsDataGrid data={data} columnLabels={summaryColumnLabels}/>
            </TabPanel>
            <TabPanel index={1} activeTab={activeGridTab}>
                <OrganisationDataGrid filters={filters} bouncedFilters={bouncedFilters} updateFilters={updateFilters}/>
            </TabPanel>
            <Snackbar
                open={copyAlert}
                anchorOrigin={{"vertical": "bottom", "horizontal": "right"}}
                autoHideDuration={6000}
                onClose={handleCloseSnackBar}
            >
                <Alert severity="success">Summary data copied to clipboard</Alert>
            </Snackbar>
        </Stack>
    );
};

export default LevelTabs;
